import { useMemo } from 'react'
import PropTypes from 'prop-types'
import { Text } from '@leroy-merlin-br/backyard-react-ui'

import formatPriceToBRL from 'reactUtils/formatPriceToBRL'

import * as S from './styled'

const Summary = ({
  subTotal,
  discount,
  total,
  servicesSubTotal
}) => {
  const hasDiscount = useMemo(() => {
    return discount > 0
  }, [discount])

  const hasSubtotal = useMemo(() => {
    return Math.floor(subTotal) !== Math.floor(total) && subTotal > 0
  }, [subTotal, total])

  const hasServicesSubtotal = useMemo(() => {
    return servicesSubTotal > 0
  }, [servicesSubTotal])

  return (
    <S.Wrapper>
      {
        hasSubtotal &&
          <S.Section>
            <Text as="div" size="giga" noMargin bold>Subtotal:</Text>
            <Text as="div" size="giga" noMargin bold>{formatPriceToBRL(subTotal)}</Text>
          </S.Section>
      }
      {
        hasDiscount &&
          <S.Section discount={discount}>
            <Text as="div" size="giga" noMargin bold>Desconto:</Text>
            <S.Discount as="div" size="giga" noMargin bold>-{formatPriceToBRL(discount)}</S.Discount>
          </S.Section>
      }
      {
        hasServicesSubtotal &&
          <S.Section>
            <Text as="div" size="giga" noMargin bold>Serviço de Instalação:</Text>
            <Text as="div" size="giga" noMargin bold>{formatPriceToBRL(servicesSubTotal)}</Text>
          </S.Section>
      }
      <S.Section>
        <Text as="div" size="giga" noMargin bold>Total:</Text>
        <Text as="div" size="giga" noMargin bold>{formatPriceToBRL(total)}</Text>
      </S.Section>
    </S.Wrapper>
  )
}

Summary.propTypes = {
  discount: PropTypes.number,
  subTotal: PropTypes.number,
  total: PropTypes.number,
  servicesSubTotal: PropTypes.number
}

export default Summary
